/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Faq_Q1Inputs */

const en_to_csv_faq_q1 = /** @type {(inputs: To_Csv_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What JSON structure works best for CSV?`)
};

const ko_to_csv_faq_q1 = /** @type {(inputs: To_Csv_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어떤 JSON 구조가 CSV에 적합한가요?`)
};

const ja_to_csv_faq_q1 = /** @type {(inputs: To_Csv_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのJSON構造がCSVに適していますか？`)
};

/**
* | output |
* | --- |
* | "What JSON structure works best for CSV?" |
*
* @param {To_Csv_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_faq_q1 = /** @type {((inputs?: To_Csv_Faq_Q1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Faq_Q1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_faq_q1(inputs)
	if (locale === "ko") return ko_to_csv_faq_q1(inputs)
	return ja_to_csv_faq_q1(inputs)
});